import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedUser: null, // used for viewing user details
  selectedUsers: [] // used for exporting
};

const usersTable = createSlice({
  name: 'usersTable',
  initialState,
  reducers: {
    setSelectedUser(state, action) {
      const { selectedUser } = action.payload;
      state.selectedUser = selectedUser;
    },
    setSelectedUsers(state, action) {
      const { selectedUsers } = action.payload;
      state.selectedUsers = selectedUsers;
    }
  }
});

export const {
  setSelectedUser,
  setSelectedUsers
} = usersTable.actions;

export default usersTable.reducer;